<template>
  <div>
    <div class="home-lottery-component" v-for="(item, idx) in list" :key='idx'>
      <div class="lottery-component" :class="`DF_${item.lotteryTypeCode}`"
        v-if="item.lotteryTypeCode == type || type == 'all' || item.lotteryCode == lotteryCode">
        <div class="lottery-container" :class="`DF_${item.lotteryTypeCode}`">
          <div class="lottery-info">
            <div class="lottery-name">{{ item.lotteryName }}</div>
            <div class="lottery-icon">
              <img v-if="appConfig.hasOwnProperty('lotteryUrl')" :src="cdn + '/' +appConfig.lotteryUrl+'/' + (item.iconCode||item.lotteryCode) + '.png'" alt />
              <img v-else :src="cdn + 'app/lottery_images/openlottery/DAFA_' + item.lotteryTypeCode + '.png'" alt />
            </div>
          </div>
          <div class="lottery-result border-left">
            <div class='issue-title' v-if="lotteryOpenPeriods(item)&&item">
              <span>第 <span class="text-focus issue-text">{{ lotteryOpenPeriods(item).periodsNumber }}</span> 期开奖号码
              </span>
              <!-- <span class="text-assist" v-if="item.periodsNumberAddRule == 1 && item.countOfDay">
                已开
                <span class="text-focus open-text">
                  {{ Number(lotteryOpenPeriods(item).periodsNumber.slice(8)) }}
                </span>
                期
              </span>
              <span class="text-assist" v-else-if="item.periodsNumberAddRule != 1">
                已开
                <span class="text-focus open-text">
                  {{ item.uziyongyuandeshen }}
                </span>
              </span>
              <span class="text-assist fl-10" v-if="item.periodsNumberAddRule == 1 && item.countOfDay">
                剩余
                <span class="text-focus open-text">
                  {{ item.countOfDay - lotteryOpenPeriods(item).periodsNumber.slice(8) }}
                </span>
                期
              </span>
              <span class="text-assist fl-10" v-else-if="item.periodsNumberAddRule == 1 && item.countOfDay">
                剩余
                <span class="text-focus open-text">
                  {{ item.countOfDay - item.uziyongyuandeshen }}
                </span>
                期
              </span> -->
            </div>
            <div class='issue-title' v-else>
              <h3>当前暂无数据</h3>
            </div>
            <div class="results">
              <lotteryNumberDF :lottery="lotteryOpenPeriods(item)" :LatelyLpVoDetail="item"
                :bigClass="item.lotteryTypeCode" :lotteryCode="item.lotteryCode" />
            </div>
          </div>
          <div class="lottery-open border-left">
            <div v-if="item[item.status]"> 距 <span class="text-focus issue-text"> {{ item[item.status].periodsNumber }}</span> 期开奖还有：</div>
            <div>
              <template v-if="item.current != undefined">
                <countTime @endCountDown="endCountDown(item)"
                  :endDate="item[item.status] && item[item.status].autoCloseDate" :lottery="lotteryOpenPeriods(item)" />
              </template>
              <template v-else>
                <countTime @endCountDown="endCountDown(item)"
                  :endDate="item[item.status] && item[item.status].autoOpenDate" :lottery="lotteryOpenPeriods(item)" />
              </template>
            </div>
          </div>
          <div class="lottery-more">
            <button class="btn" v-if="page == 'lotteryrecord' || page == ''" @click="toRouteRecod(item)">
              <i class="iconfont icon-record"></i>
              走势图表
            </button>
            <button class="btn" v-if="page == 'lotterychart'|| page == ''" @click="toRoute(item)">
              <i class="iconfont icon-trend" style="font-size: 12px;"></i>
              开奖记录
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mix from "~/mixins/home.mixins.vue";
export default {
  mixins: [mix],
  props: {
    list: {
      type: Array
    },
    cdn: {
      type: String
    },
    type: {
      type: String
    },
    lotteryCode: {
      type: String
    },
    page:{
      type:String,
      default:''
    }
  },
  data() { },
  mounted() {
  },
  methods: {
    toRoute(item){
      this.$router.push({
        name: "lotteryrecord",
        query: {
          lotteryTypeCode: item.lotteryTypeCode,
          lotteryCode: item.lotteryCode,
        },
      });
    },
    toRouteRecod(item){
      this.$router.push({
        name: "lotterychart",
        query: {
          lotteryTypeCode: item.lotteryTypeCode,
          lotteryCode: item.lotteryCode,
        },
      });
    }
  }

}
</script>
<style lang="less">
.home-lottery-component {
  margin-bottom: 20px;
  background: #fff;

  .lottery-component {
    margin-bottom: 20px;
    background: #fff;

    .lottery-container {
      width: 1200px;
      height: 160px;
      border: 1px solid #e0e0e0;
      box-shadow: 0 4px 6px rgba(0, 0, 0, .04);
      display: flex;
      color: #333;
      font-size: 16px;
      position: relative;

      .lottery-info {
        width: 215px;
        border-left-width: 6px;
        border-left-style: solid;
        padding: 15px 0;
        flex-direction: column
      }

      .lottery-name {
        font-weight: 500;
        font-size: 22px;
        position: relative;
        z-index: 1;
        margin-bottom: 8px
      }

      .lottery-icon {
        width: 100px;
        height: 100px;
        overflow: hidden;

        img {
          width: 80px;
          -webkit-box-reflect: below -5px -webkit-linear-gradient(top, rgba(250, 250, 250, 0.3), rgba(250, 250, 250, 0.3) 30%, rgba(250, 250, 250, 0));
          box-reflect: below -5px linear-gradient(top, rgba(250, 250, 250, 0.3), rgba(250, 250, 250, 0.3) 30%, rgba(250, 250, 250, 0));
        }
      }

      .lottery-result {
        width: 527px;
        padding: 14px 30px;
        box-sizing: border-box;
      }

      .results ul li {
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      .issue-title>span:first-child {
        margin-right: 16px
      }

      .issue-title>span:last-child:not(:first-child) {
        margin: 0 10px;
      }

      .text-focus {
        color: red;
      }

      .lottery-name:after {
        content: "";
        width: 90%;
        height: 14px;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: -1
      }

      .home-lottery-component .lottery-container>div.border-left {
        margin: 15px 0;
        border-left: 1px dashed #dbdbdb;
      }
    }
  }

  .lottery-component.SSC {
    background: linear-gradient(90deg, #fff7f0 .5%, rgba(255, 250, 248, 0) 22.2229%)
  }

  .lottery-container>div:first-child {
    display: flex;
    justify-content: center;
    align-items: center
  }

  .lottery-container .lottery-open {
    width: 280px;
    padding: 14px 0 0 38px;
    box-sizing: border-box;
  }

  .lottery-container .lottery-more button+button {
    margin-top: 20px
  }

  .lottery-container .lottery-more .btn {
    width: 118px;
    height: 38px;
    text-decoration: none;
    color: #4973df;
    border: 1px solid #4973df;
    border-radius: 2px;
    background-color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      margin-right: 5px;
      font-style: normal;
    }
  }

  .lottery-container .lottery-more .btn:active,
  .lottery-container .lottery-more .btn:hover {
    color: #fff;
    background: linear-gradient(180deg, #657cf3, #4c6bdb 118.06%)
  }

  .lottery-container .lottery-more {
    width: 191px;
    flex-direction: column;
    box-sizing: border-box;
  }

  .lottery-container .lottery-open .time-count>div {
    width: 56px;
    height: 48px;
    border-radius: 2px;
    background: linear-gradient(180deg, #717171, #4a4a49);
    color: #fff;
    font-size: 30px;
    line-height: 48px;
    text-align: center;
    margin-right: 14px
  }

  .lottery-open .time-count {
    padding-top: 29px;
    display: inline-flex;
    align-items: center;
  }

  .lottery-container>div:nth-child(4n) {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-right: 40px
  }

  .lottery-container>div.border-left {
    margin: 15px 0;
    border-left: 1px dashed #dbdbdb
  }

  .lottery-container.DF_SSC {
    background: linear-gradient(90deg, #fff7f0 .5%, rgba(255, 250, 248, 0) 22.2229%);
  }

  .lottery-container.DF_SSC .lottery-info {
    border-left-color: #fc8d26
  }

  .lottery-container.DF_SSC .lottery-info .lottery-name:after {
    background-color: #ffe7d1
  }

  .lottery-container.DF_K3 {
    background: linear-gradient(90deg, #fff5f5 .5%, rgba(255, 249, 248, 0) 22.2229%)
  }

  .lottery-container.DF_K3 .lottery-info {
    border-left-color: #e41404
  }

  .lottery-container.DF_K3 .lottery-info .lottery-name:after {
    background-color: #ffdbdb
  }

  .lottery-container.DF_ZHISHU {
    background: linear-gradient(90deg, #fff6fb .5%, rgba(255, 250, 248, 0) 22.2229%);
  }

  .lottery-container.DF_ZHISHU .lottery-info {
    border-left-color: #f43000
  }

  .lottery-container.DF_ZHISHU .lottery-info .lottery-name:after {
    background-color: #ffc7b9
  }

  .lottery-container.DF_DLT {
    background: linear-gradient(90deg, #fff5f5 .5%, rgba(255, 249, 248, 0) 22.2229%)
  }

  .lottery-container.DF_DLT .lottery-info {
    border-left-color: #fb25f5
  }

  .lottery-container.DF_DLT .lottery-info .lottery-name:after {
    background-color: #fee3ff
  }

  .lottery-container.DF_PK10 {
    background: linear-gradient(90deg, #fff6fb .5%, hsla(0, 100%, 98%, 0) 22.2229%)
  }

  .lottery-container.DF_PK10 .lottery-info {
    border-left-color: #f22751
  }

  .lottery-container.DF_PK10 .lottery-info .lottery-name:after {
    background-color: #ffdbf0
  }

  .lottery-container.DF_PCDD {
    background: linear-gradient(90deg, #fff5f5 .5%, rgba(255, 249, 248, 0) 22.2229%)
  }

  .lottery-container.DF_PCDD .lottery-info {
    border-left-color: #00c5ef
  }

  .lottery-container.DF_PCDD .lottery-info .lottery-name:after {
    background-color: #c4f5ff
  }

  .lottery-container.DF_SSQ {
    background: linear-gradient(90deg, #fff6fb .5%, hsla(0, 100%, 98%, 0) 22.2229%)
  }

  .lottery-container.DF_SSQ .lottery-info {
    border-left-color: #4962ff
  }

  .lottery-container.DF_SSQ .lottery-info .lottery-name:after {
    background-color: #cbd3ff
  }

  .lottery-container.DF_LHC {
    background: linear-gradient(90deg, #f7fffc .5%, rgba(249, 255, 253, 0) 22.2229%)
  }

  .lottery-container.DF_LHC .lottery-info {
    border-left-color: #07b39e
  }

  .lottery-container.DF_LHC .lottery-info .lottery-name:after {
    background-color: #c7f4e1
  }

  .lottery-container.DF_11X5 {
    background: linear-gradient(90deg, #f7fcff .5%, rgba(247, 253, 255, 0) 22.2229%)
  }

  .lottery-container.DF_11X5 .lottery-info {
    border-left-color: #2192dd
  }

  .lottery-container.DF_11X5 .lottery-info .lottery-name:after {
    background-color: #d3efff
  }

  .lottery-container.DF_3D {
    background: linear-gradient(90deg, #f7fbff .5%, rgba(247, 255, 255, 0) 22.2229%)
  }

  .lottery-container.DF_3D .lottery-info {
    border-left-color: #41c3ec
  }

  .lottery-container.DF_3D .lottery-info .lottery-name:after {
    background-color: #cbf2f4
  }

  .lottery-container.DF_PL3 {
    background: linear-gradient(90deg, #f9fff7 .5%, rgba(249, 255, 247, 0) 22.2229%)
  }

  .lottery-container.DF_PL3 .lottery-info {
    border-left-color: #38b366
  }

  .lottery-container.DF_PL3 .lottery-info .lottery-name:after {
    background-color: #d3f1c5
  }
}
</style>